var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("IIP logout complete")]),_c('div',{staticClass:"ma-4"},[_c('v-btn',{attrs:{"link":"","x-large":"","color":"primary"},on:{"click":_vm.login}},[_vm._v(" Login ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }